"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWeightProperty = exports.weightPropertyDefinition = void 0;
exports.weightPropertyDefinition = {
    view: { label: 'Weight' },
    constraints: [],
    type: 'text',
    multiple: false,
    name: 'weight',
};
const isWeightProperty = (prop) => {
    return prop.name === exports.weightPropertyDefinition.name;
};
exports.isWeightProperty = isWeightProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2VpZ2h0LnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvd2VpZ2h0LnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsd0JBQXdCLEdBQUc7SUFDdEMsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLFFBQVEsRUFBRTtJQUN6QixXQUFXLEVBQUUsRUFBRTtJQUNmLElBQUksRUFBRSxNQUFNO0lBQ1osUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsUUFBUTtDQUNpQixDQUFBO0FBSTFCLE1BQU0sZ0JBQWdCLEdBQUcsQ0FBQyxJQUFrQixFQUEwQixFQUFFO0lBQzdFLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxnQ0FBd0IsQ0FBQyxJQUFJLENBQUE7QUFDcEQsQ0FBQyxDQUFBO0FBRlksUUFBQSxnQkFBZ0Isb0JBRTVCIn0=